import React, { Fragment } from 'react'
import { Table, TableBody, TableCell, TableContainer,
   TableHead, TableRow, Paper, TablePagination} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import PropTypes from 'prop-types';
import TableFooter from '@mui/material/TableFooter';
import IconButton from '@mui/material/IconButton';
import FirstPageIcon from '@mui/icons-material/FirstPage';
import KeyboardArrowLeft from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRight from '@mui/icons-material/KeyboardArrowRight';
import LastPageIcon from '@mui/icons-material/LastPage';
import Box from '@mui/material/Box';
import { useState } from 'react';
import styled from 'styled-components';
import AddIcon from '@mui/icons-material/Add';
import RMreadonlyrow from './RMreadonlyrow';
import RMeditablerow from './RMeditablerow';
import RSubjectMaster from './RSubjectMaster';
import { useEffect } from 'react';
import { useAddNewComplMasterMutation, useGetComplMastersQuery, useUpdateComplMasterMutation, useDeleteComplMasterMutation  } from '../../../features/complmaster/complmasterApiSlice';
import { useGetReqMastersQuery, useAddNewReqMasterMutation, useUpdateReqMasterMutation, useDeleteReqMasterMutation} from '../../../features/reqmaster/reqmasterSlice';
import Select from '@mui/material/Select';
import {OutlinedInput, MenuItem, Chip, Stack} from '@mui/material';
import { useGetAssetMastersQuery } from '../../../features/assetmasterApiSlice/assetmasterApiSlice';
import {HeadingWrap, Span, CommonButton } from '../../../Styles/CommonStyles';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import CheckBoxIcon from '@mui/icons-material/CheckBox';
import ExcelDownload from '../../../data/exceldownload';


const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const Addcategcont =styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  margin-right: 20px;
`
const Addcategform = styled.form`
  display: flex;
  margin:10px;
`
const Displaydiv1 = styled.div`

`
const HeadingField = styled.div`
  font-weight: bold;
  margin-bottom:20px;
  margin-top:15px;
`

const AssetCategoryWrapper = styled.div`

`
const Label = styled.label`
    width: 140px;
    margin: 10px;
`
const ComplaintCategoryWrapper =styled.div`
  display: flex;

`

function TablePaginationActions(props) {
  const theme = useTheme();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleFirstPageButtonClick = (event) => {
    onPageChange(event, 0);
  };

  const handleBackButtonClick = (event) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event) => {
    onPageChange(event, page + 1);
  };

  const handleLastPageButtonClick = (event) => {
    onPageChange(event, Math.max(0, Math.ceil(count / rowsPerPage) - 1));
  };


  return (
    <Box sx={{ flexShrink: 0, ml: 2.5 }}>
      <IconButton
        onClick={handleFirstPageButtonClick}
        disabled={page === 0}
        aria-label="first page"
      >
        {theme.direction === 'rtl' ? <LastPageIcon /> : <FirstPageIcon />}
      </IconButton>
      <IconButton
        onClick={handleBackButtonClick}
        disabled={page === 0}
        aria-label="previous page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowRight /> : <KeyboardArrowLeft />}
      </IconButton>
      <IconButton
        onClick={handleNextButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="next page"
      >
        {theme.direction === 'rtl' ? <KeyboardArrowLeft /> : <KeyboardArrowRight />}
      </IconButton>
      <IconButton
        onClick={handleLastPageButtonClick}
        disabled={page >= Math.ceil(count / rowsPerPage) - 1}
        aria-label="last page"
      >
        {theme.direction === 'rtl' ? <FirstPageIcon /> : <LastPageIcon />}
      </IconButton>
    </Box>
  );
}

TablePaginationActions.propTypes = {
  count: PropTypes.number.isRequired,
  onPageChange: PropTypes.func.isRequired,
  page: PropTypes.number.isRequired,
  rowsPerPage: PropTypes.number.isRequired,
};


export default function CustomPaginationActionsTable() {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [values, setValues] =useState({
    Category:"",
    Asset:[]  
  });


  const {reqmaster} = useGetReqMastersQuery('arg', {
    selectFromResult: ({ data }) => ({
      reqmaster: data?.entities
    }),
  })
  
  const [addNewReqMaster] = useAddNewReqMasterMutation();
  const [updateReqMaster] = useUpdateReqMasterMutation();
  const [deleteReqMaster] = useDeleteReqMasterMutation();
  const [tabledata, setTabledata]= useState([]);
  const [categProp, setCategProp]= useState();
  const [categPropId, setCategPropId]= useState();
  const [editCategory, setEditCategory]=useState(null);
  const [editFormData, setEditFormData]=useState({});
  const [addCategData, setAddCategData] = useState({});
  const [assetCategory, setAssetCategory]=useState([]);
  const [sentData, setSentData ]= useState(0);
  const [subject, setSubject] = useState({
    subjectValue: [...Array(tabledata.length).fill("")],
    subjectIndex: ""
  });
  const [subCategPage, setSubCategPage] = useState(false)

     // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - tabledata.length) : 0;

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const onClickAddSubCateg = (e,k) => {
    setCategProp(tabledata[k]?.Category)
    setCategPropId(tabledata[k]?.id)
    setSubCategPage(true)       
  }

  const onSubmit = async (event) =>{
    event.preventDefault();
    try{
      let bodyobject ={"Category":addCategData.Category, "ApplAssetCateg":addCategData.assetCategories, "Subject":[]};
      const found = Object.values(reqmaster).some(el => el.Category === editFormData.Category);
      
   if(!found && addCategData?.Category?.length ){
      const res = await addNewReqMaster(bodyobject) ;
      setAddCategData({});
      setSentData(sentData+1);
      }
    } catch(err){console.log(err)}
  }

  // useEffect(() => {
  //   if (formState.isSubmitSuccessful) {
  //     reset({ Category: '' });
  //   }
  // }, [formState, reset]);

  const onClickEdit = (e,k,row)=>{

    if((subject.subjectValue[k] === "") ||(subject.subjectValue[k] === undefined)){
      const temp = {...subject}
      temp.subjectIndex ="";
      setSubject(temp);
    }
    setEditCategory(k+1);

  }

  const onChangeAddCateg = (event) =>{
    let temp ={...addCategData}
    temp = {...temp, [event.target.name]:event.target.value}
    setAddCategData(temp);
  }

  const onChangeEditCateg = (event) =>{
    let val = event.target.name;
    let temp ={...editFormData}
    if(event.target.name.includes("Category")){
    temp = {...temp, [event.target.name]:event.target.value}
    }
    if(event.target.name.includes("Subject")){
      let tempArray = [...temp[event.target.name]]
      tempArray[subject.subjectIndex] = event.target.value;
      temp = {...temp, [event.target.name]:tempArray}
    }
    if(event.target.name.includes("assetCategories")){
      temp = {...temp, [event.target.name]:event.target.value}
    }
    setEditFormData(temp);
  }

  const handleEditFormSubmit = async (e) =>{
    e.preventDefault();
    try{
    setEditCategory(null);
    const id = tabledata[((page)*(rowsPerPage))+(editCategory-1)].id;
    let body ={}
    body = {...body, ["Category"]:editFormData[`Category${((page)*(rowsPerPage))+(editCategory-1)}`]}
    if ((editFormData[`Subject${((page)*(rowsPerPage))+(editCategory-1)}`] !== []) && (editFormData[`Category${((page)*(rowsPerPage))+(editCategory-1)}`] !== "") && (editFormData[`Subject${((page)*(rowsPerPage))+(editCategory-1)}`] !== undefined)  ){ 
    body = {...body, "Subject":editFormData[`Subject${((page)*(rowsPerPage))+(editCategory-1)}`][subject.subjectIndex], "SubjectIndex":subject.subjectIndex, "id":id}
    }
    console.log(body)
    const response = await  updateReqMaster(body)
    setSentData(body);
    }catch(err){}
  }
  

  const handleCancelClick = (e,k) => {    
    const tempObject = {...subject};
    tempObject.subjectValue[k] = "";
    setEditCategory(null);
    setSubject(tempObject);
  };

  const handleDeleteClick = async (e,k,id) => {
    e.preventDefault();
    let body = {"id":id}
    const result = await deleteReqMaster(body);
    setSentData(id);    
  };  
  
  const onChangeSub = (e,k) =>{
    const tempObject = {...subject};
    if(e.target.value === "Select"){
      tempObject.subjectValue[k] = "";      
    }
    else{
      tempObject.subjectValue[k] = e.target.value;
      tempObject.subjectIndex = tabledata[k].Subject.indexOf(e.target.value);
    }
    setSubject(tempObject);
  }
  const onClickBackArrow = () =>{
    setSubCategPage(false);
  }

  useEffect(()=>{
    if(reqmaster){
      const reqmasterArray = Object.values(reqmaster);
      setTabledata(reqmasterArray);
      let temp = {...editFormData};
      for(let i=0;i< reqmasterArray.length;i++){
        temp = {...temp, [`Category${i}`]:reqmasterArray[i].Category, [`Subject${i}`]:reqmasterArray[i].Subject}
      }
      setEditFormData(temp);
    }
  },[reqmaster, subject])

   
  return (
    <>
    { !subCategPage ?
    <Displaydiv1>
       <HeadingWrap>
        <Span>Add New Office Type</Span>
      </HeadingWrap>
      <HeadingField>Add New Complaint Category</HeadingField>
    {/* <Addcategcont>
      <AddIcon/>
      <div>Add New Category</div>      
    </Addcategcont> */}
    <ComplaintCategoryWrapper>
    <Addcategform onSubmit={onSubmit}>
      <label>Category Name</label>
      <input name='Category' placeholder="Enter a Category" onChange={onChangeAddCateg}/>
      <button type='submit'>Submit</button>
    </Addcategform>
    
    </ComplaintCategoryWrapper>

    <form onSubmit={handleEditFormSubmit}>

    <TableContainer component={Paper}  >
      <Table  aria-label="custom pagination table">
      <TableHead>
        <TableRow>
          <TableCell>Sl.No.</TableCell>
          <TableCell align="left">Complaint Category</TableCell>
          <TableCell align="left">Subject</TableCell>
          <TableCell align="left">Edit</TableCell>
        </TableRow>
      </TableHead>

      <TableBody>
        {(rowsPerPage > 0
          ? tabledata.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage): tabledata
          ).map((row, key) => ( 
            <Fragment key={key*2}>
              {editCategory=== key+1 ?
              
               <RMeditablerow row={row} k={key} editFormData={editFormData} subject={subject} 
                handleCancelClick={handleCancelClick} page={page} rowsPerPage={rowsPerPage}
                onChangeEditCateg={onChangeEditCateg} assetCategory={assetCategory}
               />

                :<RMreadonlyrow row={row} k={key} tabledata={tabledata} onClickEdit={onClickEdit}
                  handleDeleteClick= {handleDeleteClick} onClickAddSubCateg={onClickAddSubCateg}
                  onChangeSub={onChangeSub} page={page}rowsPerPage={rowsPerPage} editCategory={editCategory}                 
                />
                 }
            </Fragment>                   
          ))}
          {emptyRows > 0 && (
            <TableRow style={{ height: 53 * emptyRows }}>
              <TableCell colSpan={6} />
            </TableRow>
          )}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TablePagination
              rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
              colSpan={3}
              count={tabledata.length}
              rowsPerPage={rowsPerPage}
              page={page}
              SelectProps={{
                inputProps: {
                  'aria-label': 'rows per page',
                },
                native: true,
              }}
              onPageChange={handleChangePage}
              onRowsPerPageChange={handleChangeRowsPerPage}
              ActionsComponent={TablePaginationActions}
            />
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
    </form>
    </Displaydiv1>:
    <RSubjectMaster categProp={categProp} categPropId= {categPropId} onClickBackArrow={onClickBackArrow}
    setSentData={setSentData} reqmaster={reqmaster} deleteReqMaster={deleteReqMaster}/>
    } 
      
    </>
  );
}